import { render, staticRenderFns } from "./WxFollowQr.vue?vue&type=template&id=3bff02e3&scoped=true"
import script from "./WxFollowQr.vue?vue&type=script&lang=js"
export * from "./WxFollowQr.vue?vue&type=script&lang=js"
import style0 from "./WxFollowQr.vue?vue&type=style&index=0&id=3bff02e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bff02e3",
  null
  
)

export default component.exports